import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import * as UserActions from '../../actions/UserActions'
import * as Helper from '../../utils/Helper'
import Header from './parts/Header'
import Footer from '../after_login/parts/Footer'
import { Helmet } from "react-helmet";
import Lottie from 'react-lottie';
import * as rocket from '../lottie/36418-cecil-portfolio-background.json'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
// import { Link } from 'react-scroll'
// import eval_sample4 from '../../images/eval_sample4.jpg'
import shabelabo_web_top from '../../images/shabelabo_web_top.png'
import point_whiteback from '../../images/point_whiteback.png'
import ContactFormPart from './parts/ContactFormPart'

// lottie
let lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: rocket.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

// example of specifying audio url
let code1 = [
  "import axios from 'axios'",
  "",
  "let results_1 = await axios.post(<APIのエンドポイント>, {",
  " audio_url: <音声ファイルのURL>,",
  " response_type: 'v2',",
  "}, {",
  " headers: {",
  "  'Accept': 'application/json',",
  "  'Authorization': <APIのキー>,",
  " },",
  "})",
]
let code_str1 = code1.join("\n")

// example of sending audio
let code2 = [
  "import axios from 'axios'",
  "",
  "let audio_data = fs.readFileSync(<音声ファイルのパス>)",
  "let audio_base64 = audio_data.toString('base64')",
  "",
  "let results_1 = await axios.post(<APIのエンドポイント>, {",
  "  audio: audio_base64,",
  "  response_type: 'v2',",
  "}, {",
  "  headers: {",
  "    'Accept': 'application/json',",
  "    'Authorization': <APIのキー>,",
  "  },",
  "})"
]
let code_str2 = code2.join("\n")


// AppStart
const AppStart = (props) => {

  let navigate = useNavigate();
  let dispatch = useDispatch();

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    let _rtnObj = await Helper.loginWithToken()
    if (_rtnObj.status === true) {

      // update props
      dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

      // redirect
      navigate("/dashboard")

    }
  }


  // if domain is alphatest.shabelab.com
  // then show nothing...
  if (window.location.hostname === "alphatest.shabelab.com") {

    return (
      <div>

        <Helmet>
          <meta charSet="utf-8" />
          <title>喋ラボCLOUD | トップ</title>
          <meta name="description" content="喋ラボCLOUDは喋ラボの音声認識AIのクラウドサービスです。" />
        </Helmet>

        <div style={{
          backgroundColor: '#008CC8',
        }}>

          {/* header */}
          <Header />

        </div>


        {/* footer */}
        <Footer />

      </div>
    )


  }


  return (
    <div>

      <Helmet>
        <meta charSet="utf-8" />
        <title>喋ラボCLOUD | トップ</title>
        <meta name="description" content="喋ラボCLOUDは喋ラボの音声認識AIのクラウドサービスです。" />
      </Helmet>

      <div style={{
        backgroundColor: '#008CC8',
      }}>

        {/* header */}
        <Header />

        {/*<Container style={{
        }}>
          <img src={shabelabo_web_top} style={{
            width: '100%',
            height: 'auto',
            marginBottom: 40,
          }} />
        </Container>*/}

      </div>

      {/* body */}
      <div id="main_contents1" style={{
        backgroundColor: '#ffffff',
      }}>

        <Container>


          {/* sales pitch */}
          {/*<Row style={{
            paddingTop: 40,
            marginTop: 40,
            marginBottom: 40,
          }}>
            <Col md="2" xs="12" />
            <Col md="8" xs="12" style={{
              textAlign: 'center',
            }}>
              <img src={point_whiteback} style={{
                width: '100%',
              }} />
            </Col>
            <Col md="2" xs="12" />
          </Row>*/}

          {/* abstract */}
          <Row style={{
            paddingTop: 60,
            marginTop: 40,
            marginBottom: 40,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'center',
            }}>
              <h2 style={{
                fontSize: 42,
                fontWeight: 'bold',
              }}>
                概要
              </h2>
            </Col>
          </Row>
          <Row style={{
            marginTop: 40,
            marginBottom: 40,
          }}>
            <Col md="2" xs="12" />
            <Col md="8" xs="12" style={{
              textAlign: 'center',
            }}>
              <span style={{
                fontSize: 26,
                // fontWeight: 'bold',
              }}>
                喋ラボCLOUDは音声認識エンジンが湯水のように使えたら面白いビジネスモデルがもっと出てくるんじゃないか？じゃやってみようというコンセプトの元開発されました。ベネフォットはまず他社に比べて低価格であることです。ですが、魅力はそれだけではありません。カスタムモデルの学習とそのモデルのホスティングも行っておりますので、独自モデルを安価にかつスケーラブルに運用する事も可能です。
              </span>
            </Col>
            <Col md="2" xs="12" />
          </Row>

        </Container>
      </div>

      <div id="main_contents2">

        <Container>

          {/* simple api */}
          <Row style={{
            paddingTop: 60,
            marginTop: 20,
            marginBottom: 0,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'center',
            }}>
              <h2 style={{
                fontSize: 42,
                fontWeight: 'bold',
              }}>
                シンプルなAPI
              </h2>
            </Col>
          </Row>
          <Row style={{
            marginTop: 60,
            marginBottom: 20,
          }}>

            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 16,
              color: '#ffffff',
            }}>

              <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines={true}>
                {code_str1}
              </SyntaxHighlighter>

            </Col>

            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
              color: '#000000',
            }}>

              <span style={{
                fontWeight: 'bold',
              }}>
                音声ファイルのURLを指定する例
              </span>
              <br/>

              <span>
                APIのエンドポイントのURL、音声ファイルのURL、APIのキーの3つのパラメータを指定するだけで文字起こしの結果を取得することが可能です。
              </span>

            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>

            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 16,
              color: '#ffffff',
            }}>
              <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines={true}>
                {code_str2}
              </SyntaxHighlighter>

            </Col>

            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
              color: '#000000',
            }}>
              <span style={{
                fontWeight: 'bold',
              }}>
                音声ファイルをパスで指定する例
              </span>
              <br/>

              <span>
                APIのエンドポイントのURL、音声ファイルのパス、APIのキーの3つのパラメータを指定するだけで文字起こしの結果を取得することが可能です。
              </span>

            </Col>
          </Row>

          {/* price  */}
          {/*<Row style={{
            paddingTop: 60,
            marginTop: 20,
            marginBottom: 0,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'center',
            }}>
              <h2 style={{
                fontSize: 42,
                fontWeight: 'bold',
              }}>
                シンプルな価格設定
              </h2>
            </Col>
          </Row>
          <Row style={{
            marginTop: 40,
            marginBottom: 40,
          }}>
          <Col md="2" xs="12" />
          <Col md="4" xs="12">

            <div className="shadow2dp" style={{
              backgroundColor: '#efefef',
              width: '100%',
              textAlign: 'center',
              paddingTop: 30,
              paddingBottom: 30,
              borderColor: '#cccccc',
              borderWidth: 1,
              borderStyle: 'solid',
              backgroundColor: '#1B8CC8',
              color: '#ffffff',
            }}>
              <Row style={{
                marginTop: 0,
                marginBottom: 20,
              }}>
                <Col style={{
                  fontSize: 22,
                  fontWeight: 'bold',
                }}>
                  ベーシックプラン
                </Col>
              </Row>
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
              }}>
                <Col style={{
                  fontSize: 18,
                  textAlign: 'left',
                  paddingLeft: 60,
                }}>
                  汎用モデルのみ
                  <br/>
                  15秒につき0.24円
                  <br/>
                  毎月最初の60分は無料
                  <br/>
                  <br/>
                </Col>
              </Row>
            </div>
          </Col>

          <Col md="4" xs="12">

            <div className="shadow2dp" style={{
              backgroundColor: '#efefef',
              width: '100%',
              textAlign: 'center',
              paddingTop: 30,
              paddingBottom: 30,
              borderColor: '#cccccc',
              borderWidth: 1,
              borderStyle: 'solid',
              backgroundColor: '#1B8CC8',
              color: '#ffffff',
            }}>
              <Row style={{
                marginTop: 0,
                marginBottom: 20,
              }}>
                <Col style={{
                  fontSize: 22,
                  fontWeight: 'bold',
                }}>
                  プレミアムプラン
                </Col>
              </Row>
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
              }}>
                <Col style={{
                  fontSize: 18,
                  textAlign: 'left',
                  paddingLeft: 60,
                }}>
                  カスタムモデルのホスト可
                  <br/>
                  最低利用料金19,800円
                  <br/>
                  ※ 344時間45分までは固定
                  <br/>
                  以降、15秒につき0.24円
                  <br/>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md="2" xs="12" />
        </Row>
          <Row style={{
            marginTop: 40,
            marginBottom: 60,
          }}>
            <Col md="2" xs="12" />
            <Col md="8" xs="12" style={{
              textAlign: 'left',
            }}>
              <span style={{
                fontSize: 22,
              }}>
                カスタムモデルとは特定のユースケース向けにチューニングを行ったモデルです。チューニングは弊社、及びソリューションパートナーにて承ります。カスタムモデルについてもっと詳しく知りたい方は<a href="https://shabelab.com/craft_speech_to_text_engine" target="_blank" style={{
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  color: '#008CC8',
                }}>こちら</a>
              </span>
            </Col>
            <Col md="2" xs="12" />
          </Row>*/}

          {/* features  */}
          <Row style={{
            paddingTop: 60,
            marginTop: 20,
            marginBottom: 0,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'center',
            }}>
              <h2 style={{
                fontSize: 42,
                fontWeight: 'bold',
              }}>
                豊富な機能／特徴
              </h2>
            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 40,
          }}>

            <Col md="4" xs="12">

              <div className="shadow2dp" style={{
                backgroundColor: '#efefef',
                width: '100%',
                textAlign: 'center',
                paddingTop: 30,
                paddingBottom: 30,
                borderColor: '#cccccc',
                borderWidth: 1,
                borderStyle: 'solid',
                marginTop: 20,
                marginBottom: 20,
              }}>
                <Row style={{
                  marginTop: 0,
                  marginBottom: 20,
                }}>
                  <Col style={{
                    fontSize: 22,
                    fontWeight: 'bold',
                  }}>
                    辞書機能
                  </Col>
                </Row>
                <Row style={{
                  marginTop: 20,
                  marginBottom: 20,
                }}>
                  <Col style={{
                    fontSize: 18,
                    textAlign: 'left',
                    paddingLeft: 60,
                    paddingRight: 60,
                  }}>
                    喋ラボCLOUDのベースモデルは主にYoutubeの音源で学習をさせて頂いたモデルのため、認識できる語彙には限りがあります。ですが、辞書機能を適切に適用することにより、認識率を改善することが可能です。
                    <br/>
                  </Col>
                </Row>
              </div>

            </Col>

            <Col md="4" xs="12">
              <div className="shadow2dp" style={{
                backgroundColor: '#efefef',
                width: '100%',
                textAlign: 'center',
                paddingTop: 30,
                paddingBottom: 30,
                borderColor: '#cccccc',
                borderWidth: 1,
                borderStyle: 'solid',
                marginTop: 20,
                marginBottom: 20,
              }}>
                <Row style={{
                  marginTop: 0,
                  marginBottom: 20,
                }}>
                  <Col style={{
                    fontSize: 22,
                    fontWeight: 'bold',
                  }}>
                    Webhook対応
                  </Col>
                </Row>
                <Row style={{
                  marginTop: 20,
                  marginBottom: 20,
                }}>
                  <Col style={{
                    fontSize: 18,
                    textAlign: 'left',
                    paddingLeft: 60,
                    paddingRight: 60,
                  }}>
                    認識結果を指定のURLへポストすることも可能です。
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </Col>
                </Row>
              </div>

            </Col>

            <Col md="4" xs="12">
              <div className="shadow2dp" style={{
                backgroundColor: '#efefef',
                width: '100%',
                textAlign: 'center',
                paddingTop: 30,
                paddingBottom: 30,
                borderColor: '#cccccc',
                borderWidth: 1,
                borderStyle: 'solid',
                marginTop: 20,
                marginBottom: 20,
              }}>
                <Row style={{
                  marginTop: 0,
                  marginBottom: 20,
                }}>
                  <Col style={{
                    fontSize: 22,
                    fontWeight: 'bold',
                  }}>
                    日々進化してます
                  </Col>
                </Row>
                <Row style={{
                  marginTop: 20,
                  marginBottom: 20,
                }}>
                  <Col style={{
                    fontSize: 18,
                    textAlign: 'left',
                    paddingLeft: 60,
                    paddingRight: 60,
                  }}>
                    ポイントサイトちょびりっち社との提携により、日々新しいデータを取得、学習しています。
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </Col>
                </Row>
              </div>

            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 40,
          }}>
            <Col md="2" xs="12" />
            <Col md="8" xs="12" style={{
              textAlign: 'right',
            }}>
              <span>
                ※ その他「こんな機能が欲しい」といった事がございましたら、是非お問い合わせください。
              </span>
            </Col>
            <Col md="2" xs="12" />
          </Row>


          {/* inquiry  */}
          {/*<Row style={{
            paddingTop: 60,
            marginTop: 20,
            marginBottom: 40,
          }}>
            <Col md="2" xs="12" />
            <Col md="8" xs="12" style={{
              textAlign: 'center',
            }}>
              <Link to="/create_account" style={{
                textDecoration: 'none',
              }}>
                <div style={{
                  width: '100%',
                  paddingTop: 16,
                  paddingBottom: 16,
                  paddingLeft: 24,
                  paddingRight: 24,
                  borderRadius: 24,
                  backgroundColor: '#1B8CC8',
                  color: 'white',
                  fontSize: 32,
                  cursor: 'pointe',
                }}>
                  今すぐお問い合わせ
                </div>
              </Link>
            </Col>
            <Col md="2" xs="12" />
          </Row>
          <Row style={{
            marginTop: 60,
            marginBottom: 20,
          }}>
            <Col md="2" xs="12" />
            <Col md="8" xs="12">
              喋ラボCLOUDには60分の無料枠が用意されておりますので、無料でお試し頂けます。
              <br/>
              今すぐ登録して無料でのお試しをご希望の方は<Link to="/create_account" style={{
                color: '#008CC8',
                textDecoration: 'none',
                fontWeight: 'bold',
              }}>こちら</Link>より登録をお願いします。
              <br/>
              ※ クレジットカードの登録が必要です
              <br/>
              <br/>

            </Col>
            <Col md="2" xs="12" />
          </Row>*/}

        </Container>
      </div>

      <div style={{
        backgroundColor: '#efefef',
      }}>
        <Container>

          {/* contactus */}
          <ContactFormPart subTexts="請求書払いをご希望の方、DEMOをご希望の方はこちらからお問い合わせ頂けますでしょうか。その他のお問い合わせも下記よりお願いします。" />

        </Container>
      </div>

      {/* footer */}
      <Footer />

    </div>
  )
}

export default AppStart
